import styled from 'styled-components';

export const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(16, 42, 67, 0.38);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  font-family: 'Playfair Display', serif;
`;

export const ModalContent = styled.div`
  background: #FFFCF4;
  border-radius: 16px;
  box-shadow: 0 8px 32px 0 rgba(16, 42, 67, 0.12);
  padding: 2.5rem 2.5rem 2rem 2.5rem;
  min-width: 420px;
  max-width: 90vw;
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const ModalTitle = styled.div`
  font-family: 'Playfair Display', serif;
  font-weight: 700;
  font-size: 1.5rem;
  color: #19334D;
  margin-bottom: 2rem;
  text-align: center;
`;

export const CloseButton = styled.button`
  position: absolute;
  top: 1.25rem;
  right: 1.25rem;
  background: none;
  border: none;
  font-size: 1.5rem;
  color: #8A94A6;
  cursor: pointer;
`;

export const QRGrid = styled.div`
  display: flex;
  flex-direction: row;
  gap: 2.5rem;
  margin-bottom: 1.5rem;
`;

export const QRBlock = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const QRLabel = styled.div`
  margin-top: 1rem;
  font-size: 1.1rem;
  color: #223046;
  font-weight: 500;
`;

export const QRDesc = styled.div`
  color: #8A94A6;
  font-size: 1rem;
  margin-top: 2rem;
  text-align: center;
`;
